import type { PromotionEligibilityResponse } from '@/pages/api/promo-eligibility';
import { useQuery } from '@tanstack/react-query';

import { fetcher } from '@/utils/fetcher';
import { routes } from '@/utils/routes';
import type { WalletSetAddresses } from '@/utils/zerion/walletSet';

import { useMatchaWallets } from './useMatchaWallets';

type UsePromotionEligibilityOptions = {
  enabled?: boolean;
};

export const promotionEligibilityQueryKey = ({ evmAddress, solanaAddress }: WalletSetAddresses) =>
  ['promotion-eligibility', evmAddress, solanaAddress] as const;

export const usePromotionEligibility = ({
  enabled = true,
}: UsePromotionEligibilityOptions = {}) => {
  const { ethereumWallet, solanaWallet } = useMatchaWallets();
  const params = new URLSearchParams();

  if (ethereumWallet?.address != null) {
    params.set('evmAddress', ethereumWallet.address.toLowerCase());
  }
  if (solanaWallet != null) {
    params.set('solanaAddress', solanaWallet.address);
  }

  const url = `${routes.api.PROMOTION_ELIGIBILITY}?${params.toString()}`;

  return useQuery({
    queryKey: promotionEligibilityQueryKey({
      evmAddress: ethereumWallet?.address?.toLowerCase(),
      solanaAddress: solanaWallet?.address,
    }),
    queryFn: () => fetcher<PromotionEligibilityResponse>(url),
    enabled: enabled && (ethereumWallet?.address != null || solanaWallet?.address != null),
    staleTime: Infinity,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
  });
};
